module.exports = __webpack_public_path__ + "media/images/close-icon-d8011a88476f71b1cf9454002ed020c6.png";